/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

module.exports = {
  SET_CITY_LIST(state, list) {
    let listValue = []

    list.forEach((item) => {
      listValue.push(item.id)
    })

    state.cityList = list
    state.cityListValue = listValue
  },

  SET_TOPIC_LIST(state, list) {
    state.topicList = list;
  },

  SET_BRAND_LIST(state, list) {
    state.brandList = list;
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/vuex/mutation/common.js